﻿import smoothscroll from "smoothscroll-polyfill";
import Modal from '../modal.js';

document.addEventListener('DOMContentLoaded', () => {
    // activate the smoothscroll polyfill
    // override any existing behaviour as most browsers have smooth scrolling disabled
    window["__forceSmoothScrollPolyfill__"] = true;
    smoothscroll.polyfill();

    initVideoModals();

    function initVideoModals() {

        const ModalEvent = {
            HIDDEN: 'hidden.generic.modal',
            SHOWN: 'shown.generic.modal'
        }

        document.querySelectorAll("[id*='modal-']").forEach((modalElement) => {
            modalElement.addEventListener(ModalEvent.HIDDEN, (event) => {
                const videoElement = event.currentTarget.querySelector('video');
                stopVideo(videoElement)
            });
            modalElement.addEventListener(ModalEvent.SHOWN, (event) => {
                const currentModal = event.currentTarget;
                const videoElement = currentModal.querySelector('video');

                playVideo(videoElement)

                videoElement.addEventListener('ended', (event) => {
                    const currentVideo = event.currentTarget;
                    const currentModal = currentVideo.closest(".modal")
                    Modal.hide(currentModal);
                });

            });
        })
    }

    function stopVideo(videoElement) {
        videoElement.pause();
        videoElement.currentTime = 0;
    }

    function playVideo(videoElement) {
        videoElement.play();
    }

    var topbutton = document.getElementById("BackToTop");

    if (typeof (topbutton) != 'undefined' && topbutton != null) {
        window.addEventListener("scroll", scrollFunction);

        topbutton.addEventListener('click', function (e) {
            e.preventDefault();
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        });

        function scrollFunction() {
            var midpoint = (document.body.scrollHeight / 2) - (document.body.clientHeight)
            var midpointwebkit = (document.documentElement.scrollHeight / 2) - (document.documentElement.clientHeight)

            if (document.body.scrollTop > midpoint || document.documentElement.scrollTop > midpointwebkit) {
                topbutton.style.display = "block";
            } else {
                topbutton.style.display = "none";
            }
        }
    }

});
